var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarningInformationIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 34,
    viewBox: "0 0 40 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0L0 34H40L20 0ZM20 3.945L36.5 32H3.5L20 3.945ZM20 29C21.1046 29 22 28.1046 22 27C22 25.8954 21.1046 25 20 25C18.8954 25 18 25.8954 18 27C18 28.1046 18.8954 29 20 29ZM19 12H21V22H19V12Z",
    fill: "#F5802A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarningInformationIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/WarningInformation_icon.44a4ce7045bf93d2514363db44ab219c.svg";